import React from 'react';

/**
 * Container for a popper which is attached to a button.
 */
const ButtonPopper = props => (
  <span {...props} />
);

export default ButtonPopper;
